"use client"

import { Trans } from "@lingui/react/macro";
import DonorPortalStatusIcon from "./dpstatusicon";

import useDetectScroll, {
    Direction
} from '@smakss/react-scroll-direction';

import { useEffect, useState } from "react";

const baseNavClassName: string = "sticky left-0 bottom-0 z-50 px-5 py-5 text-sm w-full flex flex-wrap text-black bg-kexp-light-default-100";
const fadeOutAnimate: string = "transition-all ease-out duration-1000 opacity-0";
const fadeInAnimate: string = "transition-all ease-in duration-1000 opacity-100";

export default function DonorPortalFooter () {

    const { scrollDir } = useDetectScroll({thr: 10});

    const [navClassName, setNavClassName] = useState<string>( baseNavClassName );

    useEffect( () => {

        // navClassName intentionally persists the last active direction when scrollDir is Still —
        // direct computation cannot express "keep previous value when neither Up nor Down".
        if ( scrollDir == Direction.Down ) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setNavClassName( baseNavClassName + " " + fadeOutAnimate );
        } else if ( scrollDir == Direction.Up ) {
            setNavClassName( baseNavClassName + " " + fadeInAnimate );
        }

    }, [scrollDir]);

    return(
        <nav className={navClassName}>
            <div className="mr-auto">
                <ul className="flex flex-wrap justify-normal space-x-5">
                    <li>
                        © {new Date().getFullYear()} KEXP
                    </li>
                    <li>
                        <a href="https://www.kexp.org/terms-and-conditions/" className="hidden underline hover:no-underline sm:inline">
                            <Trans>Terms of Service</Trans>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.kexp.org/privacy-policy/" className="hidden underline hover:no-underline sm:inline">
                            <Trans>Privacy Policy</Trans>
                        </a>
                    </li>
                </ul>
            </div>
            <div className="ml-auto">
                <ul className="flex flex-row-reverse space-x-5">
                    <li>
                        <div className="flex"><div className="flex justify-center items-center"><DonorPortalStatusIcon /></div></div>
                    </li>
                </ul>
            </div>
        </nav>
    );
}